import { render, staticRenderFns } from "./SkeletonOfferDetailPage.vue?vue&type=template&id=45e380b5&scoped=true"
import script from "./SkeletonOfferDetailPage.vue?vue&type=script&lang=ts"
export * from "./SkeletonOfferDetailPage.vue?vue&type=script&lang=ts"
import style0 from "./SkeletonOfferDetailPage.vue?vue&type=style&index=0&id=45e380b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e380b5",
  null
  
)

export default component.exports